import APP_SETTINGS from "$/settings/app.json";
import { CRUNCH as USE_CRUNCH } from "$/settings/queries.json";
import ROUTES_SETTINGS from "$/settings/routes-resolvers.json";

const GOOGLE_PLACE_API_KEY = import.meta.env.VITE_APP_GOOGLE_PLACE_API_KEY;
const MAPBOX_API_KEY = import.meta.env.VITE_APP_MAPBOX_API_KEY;

const { CLIENT: { ROUTES = {} } = {} } = ROUTES_SETTINGS;
const isDevEnv = process.env.NODE_ENV === "development";
let CRUNCH = USE_CRUNCH;

if (isDevEnv) {
  CRUNCH = undefined;
}

const APP = {
  ...APP_SETTINGS,
  ROUTES,
};

const {
  NAMESPACE = "_",
  CONSTANTS: {
    HTTP_ONLY = "HTTP_ONLY",
    LOCAL_STORAGE = "LOCAL_STORAGE",
    FALLBACK = "FALLBACK",
    FORBIDDEN = "Forbidden",
    UNAUTHORIZED = "Unauthorized!",
    NOT_ALLOWED = "Not allowed",
  } = {},
  PREFIX = "-x",
  TOKEN_SUFFIX = "-token",
  REFRESH_TOKEN_SUFFIX = "-refresh-token",
  AUTH_HEADER_SUFFIX = "-auth-request-type",
} = APP;

const SERVER_MESSAGES = { FORBIDDEN, UNAUTHORIZED, NOT_ALLOWED };
const AUTH = {
  STRATEGIES: {
    CLIENT: {
      AUTH_HEADER: `${PREFIX}${NAMESPACE}${AUTH_HEADER_SUFFIX}`,
      HTTP_ONLY,
      LOCAL_STORAGE,
      FALLBACK,
    },
  },
};

// You may change this one only to match your needs. This is how what authentication strategy
// you want your client uses
const CLIENT_AUTH_REQUEST_TYPE = AUTH.STRATEGIES.CLIENT.FALLBACK;

const TOKEN_NAME = `${PREFIX}${NAMESPACE}${TOKEN_SUFFIX}`;
const REFRESH_TOKEN_NAME = `${PREFIX}${NAMESPACE}${REFRESH_TOKEN_SUFFIX}`;

const JWT = {
  HEADER: {
    TOKEN: {
      NAME: TOKEN_NAME,
    },
    REFRESH_TOKEN: {
      NAME: REFRESH_TOKEN_NAME,
    },
  },
  LOCAL_STORAGE: {
    TOKEN: {
      NAME: `${NAMESPACE}Token`,
    },
    REFRESH_TOKEN: {
      NAME: `${NAMESPACE}RefreshToken`,
    },
  },
  COOKIE: {
    TOKEN: {
      NAME: TOKEN_NAME,
    },
    REFRESH_TOKEN: {
      NAME: REFRESH_TOKEN_NAME,
    },
  },
};

const CLIENT_AUTHENTICATION_METHOD = {
  HTTP_ONLY:
    APP.STRATEGIES.HTTP_ONLY &&
    AUTH.STRATEGIES.CLIENT.HTTP_ONLY === CLIENT_AUTH_REQUEST_TYPE,
  LOCAL_STORAGE:
    APP.STRATEGIES.LOCAL_STORAGE &&
    (AUTH.STRATEGIES.CLIENT.LOCAL_STORAGE === CLIENT_AUTH_REQUEST_TYPE ||
      AUTH.STRATEGIES.CLIENT.FALLBACK === CLIENT_AUTH_REQUEST_TYPE),
};

export {
  APP,
  AUTH,
  JWT,
  CLIENT_AUTH_REQUEST_TYPE,
  CLIENT_AUTHENTICATION_METHOD,
  SERVER_MESSAGES,
  CRUNCH,
  GOOGLE_PLACE_API_KEY,
  MAPBOX_API_KEY,
};
